import React, { useEffect, useState } from "react";
import './SignInPage.css'
import GoogleLoginComponent  from "../../GoogleLoginComponent";

function SignInPage() {
    return (
        <div className="login-form-wrapper" >
            
            <form className="login-form">
                Sign In With Google
                <GoogleLoginComponent confirm={true}/>
            </form>
        </div>
    );
}

export default SignInPage;